import  React, { useEffect, useState } from "react"; import Menubar from "../Menubar"; import {  Container, Row, Col,Form,} from "react-bootstrap"; import { store } from "../../App"; import {Field, FormikProvider, useFormik } from "formik";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md"; import "jspdf-autotable"; import { exportToExcel, datetime, generatePdf, } from "../utils/commonFunctions"; import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert";  import Select from 'react-select'; import jsPDF from "jspdf"; 
import MasterService from "../../Services/MasterService";
import { Link } from "react-router-dom";
export default function Achievementsprogress() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [data, setData] = useState([]); const [searchText, setSearch] = useState(""); const [Periodicid, setperiodicId] = useState(); const [Periodicitylist, setPeriodicitylist] = useState();const [Yearlist, setYearlist] = useState(); const [Categorylist, setCategorylist] = useState(); const [mainEnb, setMainenb] = useState(false); const [mandalsName, setmandalsName] = useState(true); const [Deptname, setDeptname] = useState(); const [getEntered, setgetEntered] = useState(true);const[Depts,setDepts]=useState(); const[periodic, setperiodic] = useState(); const [selectedperiodicity, setselectedperiodicity] = useState(); const [enteredMandals, setEnteredMandals] = useState([]);const [notEnteredMandals, setNotEnteredMandals] = useState([]);
  let username = localStorage.getItem("username"); let deptId = localStorage.getItem("deptid"); let secretariatcode = localStorage.getItem("secretariat_code"); let roleid = localStorage.getItem("catid");  const [seclist, setseclist] = useState([]);  const [deptenb, setdeptenb] = useState(false); 
  let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");
  const formik = useFormik({ initialValues: { department_id:"", sec_id:"0" ,year:"",category:""}, 
    onSubmit: (values) => { } })
    
   
    useEffect(() => {
       let paramss = { userId: username }
      MasterService.getDeptartments(paramss).then((res) => {
        setDepts(res.data?.SDESC);
                if (res.data) { let options = res.data?.SDESC.map((item, i) => { return ( <option key={i} value={item.dept_id}> {item.dept_name} </option> ); }); 
                const updatedDeptList = [ ...res.data.SDESC, ];
                setseclist(updatedDeptList); } }); 
       
  if(["113","111","114"].includes(roleid)) {  perioicitylist(deptId);formik.setFieldValue("sec_id", secretariatcode); formik.setFieldValue("department_id", deptId);  setdeptenb(true); }

}, []);
const periodicityMap = { monthly: { label: "MONTHLY", value: "6" }, quarterly: { label: "QUARTERLY", value: "7" },half_yearly: { label: "HALFYEARLY", value: "5" }, annually: { label: "ANNUALLY", value: "3" }, bi_annual: { label: "BIENNIAL", value: "8" }, five_years: { label: "FIVE-YEARS", value: "2"}};

const perioicitylist = (dept) => {
  formik.setFieldValue("periodic_id",""); if(!dept){ setPeriodicitylist([]); return; }
    if (dept === "0") {
      const allOptions = Object.keys(periodicityMap).map((key) => ( <option key={periodicityMap[key].value} value={periodicityMap[key].value}> {periodicityMap[key].label}</option> ));
     
      setPeriodicitylist(allOptions); return;
    }
  else{
    let paramss = { userId: username, deptId: dept};
    KpiService.periodicityStatus(paramss).then((res) => {
        if (res.data?.SCODE === "01") {
          const apiData = res.data.SDESC[0]; const options = Object.keys(periodicityMap).filter((key) => apiData[key] > 0).map((key) => ( <option key={periodicityMap[key].value} value={periodicityMap[key].value}> {periodicityMap[key].label} </option> ));
          setPeriodicitylist(options);
        } else { setPeriodicitylist([]); showAlertMessage(res.data.SDESC, "warning"); 
      }
    });
}};

const YearData=(e)=>{
  formik.setFieldValue("year",""); formik.setFieldValue("category",""); setperiodicId(e.target.value); setMainenb(false);
setData([]) ;setEnteredMandals([]); setNotEnteredMandals([]);
    let params={ userId:username, periodicityId:e.target.value }
    KpiService.KpiperiodicYears(params).then((res20) => {
      let res=res20.data.SDESC.yearsList
      if (res20.data) { let options = res.map((item, i) => { return ( <option key={item.id} value={item.id}> {item.value} </option> ); }); setYearlist(options); }
    })
    setYearlist([]); setCategorylist([]);

  }

  const Categorydata = (e) => {
    const filterperiodic = periodic?.find(item=>item.periodic_id === parseInt(formik.values.periodic_id)); setselectedperiodicity(filterperiodic?.periodic_name);
    const params = { userId: username, periodicityId: Periodicid, }; KpiService.KpiperiodicYears(params).then((res) => { const response = res.data.SDESC.headList;
  if(response){ const options = response?.map((item, i) => ( <option key={item.id} value={item.id}> {item.value} </option> )); setCategorylist(options); } else{ setCategorylist([]); } });
  
  };
  
  const filteredData = searchText.length > 0 && data?.length ? data.filter((item) => item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()) ); }) ) : data;
const filteredEnteredMandals = searchText.length > 0 && enteredMandals?.length ? enteredMandals.filter((item) => item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()) ); }) ) : enteredMandals;

const filteredNotEnteredMandals = searchText.length > 0 && notEnteredMandals?.length ? notEnteredMandals.filter((item) => item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()) ); }) ) : notEnteredMandals;

  const[currentdate,setcurrentdate] =useState(''); const[currenttime,setcurrenttime] =useState('');

  useEffect(() => { datetime(setcurrentdate,setcurrenttime); }, []);


  const fetchKpiAchievementData = (category, year, buttonType, district, deptid) => {

    if (deptid && year) { setMainenb(true); } 
    const filterdept = Depts?.find(item => item.dept_id === deptid); 
    if(deptid==="0"){setDeptname("ALL")}else{
    setDeptname(filterdept?.dept_name);}
    const isPeriodicRequireAll = ["5", "6", "7"].includes(Periodicid);
    const isAnyFieldMissing = !year || !category || !deptid;
    
    if (!Periodicid || (isPeriodicRequireAll && isAnyFieldMissing)) { return; }
    store.dispatch({ type: "SHOW_SPINNER" });
  
    const params = { deptId: deptid, userId: username, year: year, periodicityId: Periodicid, headId: category ? category : "0", buttonType: buttonType, districtId:roleid==="119"||roleid==="113" ||roleid==="119"? localStorage.getItem("districtid") : district };
  
  
    KpiService.kpisAchievementReport(params).then((res) => {
        if (res.data.SCODE === "01") {
          setData(res.data.SDESC);
        } else {
          showAlertMessage(res.data.SDESC, "warning");
          setData([]);
        }
      }).catch(() => { showAlertMessage("Error fetching details. Please try again.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };
  
  const getdata = (category, year, deptid) => { fetchKpiAchievementData(category, year, "get", "0", deptid); }
const NotEntereddata = (detail) => {
  const params = { deptId: (roleid!=="119")?formik.values.department_id : detail.dept_id, userId: username, year: formik.values.year, periodicityId: Periodicid, headId: formik.values.category ? formik.values.category : "0", buttonType: "enteredAndNotEntered", 
    districtId: detail.district_code };

  KpiService.kpisAchievementReport(params)
    .then((res) => {
      if (res.data.SCODE === "01") {
        setEnteredMandals(res.data.enteredList || []); setNotEnteredMandals(res.data.notEnteredList || []);
      } else { showAlertMessage(res.data.SDESC, "warning"); setEnteredMandals([]); setNotEnteredMandals([]); }
    }).catch(() => { showAlertMessage("Error fetching details. Please try again.", "warning"); }) .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
};



    return (
        <>


                                <Menubar />
          <Container className='map-header1' fluid > <div className='sa-title'> <h2>District Wise- {ulbdeptlist.includes(formik.values.department_id)? "ULB":"Mandal"} Indicators Achievements  <span> Status  Report</span></h2> </div> </Container>
      <Container fluid style={{ width: "87%" }} className="outer-page-content-container">
              <FormikProvider value={formik} >
                        <Form onSubmit={formik.handleSubmit}>
         
 <div className='p-4 mt-2'>
              <Row>
             
                                          <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}  > <label className="mb-1 fw-bold"> HOD Name</label>
                                         
                                     <Select className="w-100" isClearable={true} isSearchable={true} name="department_id" required={true} getOptionValue={(option) => option.dept_id} getOptionLabel={(option) => option.dept_name} options={seclist} value={seclist?.find((option) => option.dept_id === formik.values.department_id) || ""} onChange={(option) => { formik.setFieldValue("department_id",option ? option.dept_id : "");perioicitylist(option ? option.dept_id : "");  }} isDisabled={deptenb} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 1000 }), }} />
                                                               
                                                              </Col> 
                                                          
                <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className='mandal-select'>
                <label htmlFor="periodic_id" className="mb-1 fw-bold"> Periodicity </label> <span style={{ color: "red" }}> *</span>
                  <Field className="mb-3 form-control" component="select" name="periodic_id" controlId="formBasicEmail"  onChange={(e)=>{YearData(e); formik.handleChange(e)}}style={{ fontWeight: "bold" }}> <option value="">--Select--</option> {Periodicitylist} </Field>
                </Col> 
                
  <>
    <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className='mandal-select'> <label htmlFor="year" className="mb-1 fw-bold"> Year </label> <span style={{ color: "red" }}> *</span> <Field className="mb-3 form-control" component="select" name="year" controlId="formBasicEmail" onChange={(e) => { Categorydata(e); formik.handleChange(e) ;getdata(formik.values.category,e.target.value,formik.values.department_id)}} style={{ fontWeight: "bold" }} > <option value="">--Select--</option> {Yearlist} </Field> </Col>
    {(Periodicid === "5" || Periodicid === "6" || Periodicid === "7")  && (
      <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className='mandal-select'>
                          <label htmlFor="category" className="mb-1 fw-bold"> Category </label> <span style={{ color: "red" }}> *</span>
        <Field className="mb-3 form-control" component="select" name="category" controlId="formBasicEmail" style={{ fontWeight: "bold" }} onChange={(e)=>{getdata(e.target.value,formik.values.year,formik.values.department_id); formik.handleChange(e) }} > <option value="">--Select--</option> {Categorylist} </Field>
      </Col>
    )}
              </>                              
              </Row>
            </div> 
            {mainEnb&&
            <>                <Row className="mt-5">
                    <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                    <div style={{display: "flex",alignItems: "center",border: "1px solid #ddd",borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px",}} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} >
                            <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} />
                            <input type="text" placeholder="Search" value={searchText} onChange={(event) => setSearch(event.target.value)} style={{flex: "1",border: "none",outline: "none",fontSize: "1rem",color: "#333",backgroundColor: "transparent",transition: "color 0.3s ease",minWidth: "0",}}/>
                        </div>
                    </Col>
                    <Col className=" mb-2 " > <button type="button" className="btn btn-danger btn-sm mx-2 pdf-btn" style={{ float: "right", marginLeft: "3px" }} onClick={() => generatePdf("#my-table", "Mandals Achievement Report",8)}> PDF <MdOutlinePictureAsPdf /> </button> <button type="button" variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "Mandals Achievement Report")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button> </Col>
                </Row>
                
   <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>
 <Row>
               <Col xs={12} sm={12} lg={12} md={12} xl={8} xxl={8}>
                    <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered sticky-table">
                        <thead  style={{ position: "sticky", top: 0, zIndex: 2 }}>
                            <tr className="text-center"> <th colSpan={8} style={{ backgroundColor: "#d4e3d8", color: "black" }}> <span style={{color:"black"}}>District Wise- {ulbdeptlist.includes(formik.values.department_id)? "ULB":"Mandal"} Indicators Achievements<br/>
                            {(roleid==="119")&& <>District - <span style={{color:"#fbb040"}}>{localStorage.getItem("districtname")} </span> </>}of HOD -<span style={{color:"#fbb040"}}>{Deptname} </span>Periodicity:<span style={{color:"#fbb040"}}>{Object.values(periodicityMap).find(item => item.value == Periodicid)?.label} </span> Entered -as on <span style={{color:"#fbb040"}}>{currentdate} </span></span> </th></tr>
                        <tr className="only-export"><th  colSpan={8} style={{ backgroundColor: "#d4e3d8", color: "black" }}><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr>            
                            
                            <tr className="text-center">
                                <th  >Sl.No.</th> {mandalsName&&<><th > {(roleid !== "119" ) ? "District" : "HOD Name"} </th> <th  >Total {ulbdeptlist.includes(formik.values.department_id)? "ULBs":"Mandals"}</th> <th  >No.of {ulbdeptlist.includes(formik.values.department_id)? "ULBs":"Mandals"} data entered</th> <th >Not entered {ulbdeptlist.includes(formik.values.department_id)? "ULBs":"Mandals"}</th> <th >% of Entered</th> <th >No.of {ulbdeptlist.includes(formik.values.department_id)? "ULBs":"Mandals"} approved at district level</th> <th >% of Approved</th></>}
                            </tr>
                        </thead>

{filteredData?.length > 0 ? (
  <>
  <tbody>
  {filteredData?.slice(0, -1).map((detail, i) => (
  <tr key={i}>
    <td style={{ textAlign: "center" }}>{i + 1}</td>

    {mandalsName && (
      <>
           <td onClick={() => NotEntereddata(detail)}> <Link> {(roleid !== "119" ) ? detail.district_name : detail.dept_name} </Link> </td> <td style={{ textAlign: "right" }}>{detail.total_mandal}</td> <td style={{ textAlign: "right" }}>{detail.mandals_data_entered}</td> <td style={{ textAlign: "right" }}>{detail.mandals_data_not_entered}</td> <td style={{ textAlign: "right", color: "green" }}>{detail.mandal_entered_per}</td> <td style={{ textAlign: "right" }}>{detail.mandals_data_approved_dist_level}</td> <td style={{ textAlign: "right", color: "green" }}>{detail.mandal_approved_per}</td>
      </>
    )}
  </tr>
))}

</tbody>
    {mandalsName && (
      <tfoot>
        <tr className="text-center">
          {(() => {
            const detail = filteredData[filteredData.length - 1];
            return (
              <>
                <td   colSpan={2} >{detail.district_name}</td> <td  style={{ backgroundColor: "#4e835c", color: "white",textAlign: "right" }}>{detail.total_mandal}</td> <td  style={{backgroundColor: "#4e835c", color: "white", textAlign: "right"}} >{detail.mandals_data_entered}</td> <td style={{backgroundColor: "#4e835c", color: "white", textAlign: "right"}} >{detail.mandals_data_not_entered}</td> <td style={{ backgroundColor: "#4e835c", color: "white",textAlign: "right"}}>{detail.mandal_entered_per}</td> <td style={{backgroundColor: "#4e835c", color: "white", textAlign: "right"}}  >{detail.mandals_data_approved_dist_level}</td> <td style={{ backgroundColor: "#4e835c", color: "white",textAlign: "right" }}>{detail.mandal_approved_per}</td>
              </>
            );
          })()}
        </tr>
      </tfoot>
    )}
  </>
) : (
  <tbody> <tr> <td className="text-center" colSpan="11"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr> </tbody>
)}

</table>
</Col>
 <Col xs={12} sm={12} lg={12} md={12} xl={4} xxl={4} >
{getEntered&&  <>
  <table bordered hover id="my-table" className="custom-table table-responsive table-striped table table-bordered sticky-table">
  <thead> <tr className="text-center"> <th >{ulbdeptlist.includes(formik.values.department_id)? "ULBs":"Mandals"} data Entered</th> <th >{ulbdeptlist.includes(formik.values.department_id)? "ULBs":"Mandals"} data Not Entered</th> </tr> </thead>
  <tbody>
  {Math.max(enteredMandals.length, notEnteredMandals.length) > 0 ? (
  Array.from({ length: Math.max(enteredMandals.length, notEnteredMandals.length) }).map((_, i) => (
    <tr key={i}>
      <td>{enteredMandals[i]?.mandal_name }</td><td>{notEnteredMandals[i]?.mandal_name }</td>
    </tr>
  ))
) : (
  <tr>
    <td className="text-center" colSpan="2">
      <b style={{ color: "red" }}>Details Not Found</b>
    </td>
  </tr>
)}

  </tbody>
</table>


</>}
</Col></Row></>
}


</Form> </FormikProvider> </Container> <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} /> </> ); }
 
 